export const namespace = 'canalplus.block.oneshop.products.cards';
export { default as Component } from './components/OffersCards';
export { default as propsFormatter } from './propsFormatter';
